import React, { createContext, useContext, useState, useEffect, useRef } from 'react';

const MobileViewContext = createContext();

export const MobileViewProvider = ({ children }) => {
  const [isMobileView, setIsMobileView] = useState(false);
  const observedDiv = useRef(null);
  
  useEffect(() => {
    if (!observedDiv.current) {
      return;
    }

    const resizeObserver = new ResizeObserver(() => {
      const currentWidth = observedDiv.current?.offsetWidth;      
      setIsMobileView(currentWidth < 990);
    });

    resizeObserver.observe(observedDiv.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <MobileViewContext.Provider value={{ isMobileView, observedDiv }}>
      {children}
    </MobileViewContext.Provider>
  );
};

export const useMobileView = () => useContext(MobileViewContext);
